var map = {
	"./added.svg": "057e",
	"./afterSelf.svg": "35d0",
	"./alarm.svg": "3c85",
	"./assets.svg": "db03",
	"./bar-code.svg": "cb8a",
	"./batch-in.svg": "c518",
	"./batch-out.svg": "849a",
	"./battery.svg": "aed5",
	"./biyan.svg": "1358",
	"./bom.svg": "e8fb",
	"./card-add.svg": "26d8",
	"./carman.svg": "3b05",
	"./category.svg": "f428",
	"./cloud.svg": "61e1",
	"./customer.svg": "b17f",
	"./dashboard.svg": "f782",
	"./delete.svg": "59a1",
	"./device-manager.svg": "9e86",
	"./device-mgr.svg": "5f83",
	"./device-monitor.svg": "8b2d",
	"./deviseM.svg": "b08d",
	"./driver.svg": "e85c",
	"./echelon.svg": "39ec",
	"./electrocar.svg": "6372",
	"./enterprise-count.svg": "c6a4",
	"./enterprise-mgr.svg": "0715",
	"./enterprise.svg": "93e1",
	"./example.svg": "30c3",
	"./export.svg": "077e",
	"./eye-open.svg": "d7ec",
	"./eye.svg": "4df5",
	"./fence.svg": "4c39",
	"./form.svg": "eb1b",
	"./home.svg": "6bbe",
	"./house.svg": "4147",
	"./information.svg": "035f",
	"./jieneng.svg": "af68",
	"./job-count.svg": "f6aa",
	"./licheng.svg": "84e7",
	"./link.svg": "18f0",
	"./log.svg": "fea0",
	"./low-speed-car.svg": "d9de",
	"./mima.svg": "b8fa",
	"./nested.svg": "dcf8",
	"./note-2.svg": "3370",
	"./om.svg": "8c6d",
	"./out-store.svg": "7fa4",
	"./param-set.svg": "517c",
	"./password.svg": "2a3d",
	"./print.svg": "04d5",
	"./put-store.svg": "8bec",
	"./query.svg": "ec18",
	"./recycle.svg": "19a9e",
	"./reported.svg": "15ba",
	"./reset.svg": "9b4b",
	"./rider.svg": "dd82",
	"./scrap.svg": "be8f",
	"./sell.svg": "73d8",
	"./settings.svg": "3fc8",
	"./sim.svg": "9776",
	"./site.svg": "c99e",
	"./star.svg": "708a",
	"./statistics.svg": "a1cf",
	"./table.svg": "47f1",
	"./teacher.svg": "361d",
	"./tree.svg": "93cd",
	"./upgrade.svg": "b33e",
	"./upload.svg": "9d82",
	"./user-edit.svg": "a93d",
	"./user-name.svg": "2198",
	"./user-square.svg": "3ff3",
	"./user.svg": "b3b5",
	"./vehicle.svg": "52c5",
	"./vehlice.svg": "0298",
	"./visual-data.svg": "0fcd",
	"./visual.svg": "fb60"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "51ff";